/**
 * FX HedgePool Inc. Proprietary and Confidential
 *
 * This source code and the algorithms implemented herein are the sole property of FX HedgePool, Inc.,
 * are confidential information, and are trade secrets of FX HedgePool, Inc.
 * Redistribution or use of this source code or the algorithms implemented herein, in whole or in part,
 * without the express written permission of FX HedgePool, Inc. is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { SessionService } from './session.service';
import { Router } from '@angular/router';
import { RoleMap } from '../models/roles.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private readonly router: Router,
    private readonly apiService: ApiService,
    private readonly sessionService: SessionService,
  ) {}

  public requestCode(email: any): Observable<any> {
    return this.apiService.postCall(`${environment.zuul}user/login`, email);
  }

  public appLogin(login: any): Observable<any> {
    return this.apiService.postCall(
      `${environment.zuul}user/login/verify`,
      login,
    );
  }

  public goToProperRoute(route?: string): void {
    this.setEntityType();
    const isAdmin = this.sessionService.isAdmin();
    const isCreditBank = this.sessionService.isCreditBank();
    const isBlotterTrader = this.sessionService.isBlotterTrader();
    const isFixingOrderTrader = this.sessionService.isFixingOrderTrader();
    if (isAdmin) {
      this.router.navigate([route == null ? '/member-view' : route]);
    } else if (isCreditBank && isBlotterTrader) {
      this.router.navigate([route == null ? '/pricer' : route]);
    } else if (isCreditBank && !isBlotterTrader) {
      this.router.navigate([route == null ? '/reports' : route]);
    } else if ((!isCreditBank && isBlotterTrader) || isFixingOrderTrader) {
      this.router.navigate([route == null ? '/blotter' : route]);
    } else {
      this.router.navigate([route == null ? '/pools' : route]);
    }
  }

  public setDefaultMember(): void {
    const jwtPayload = this.sessionService.getJWTPayload();
    const rolesMap: RoleMap = JSON.parse(jwtPayload['custom:roles']);
    const defaultMember = Object.keys(rolesMap)[0];
    if (defaultMember !== '0') {
      sessionStorage.setItem('selectedEntityId', defaultMember);
      sessionStorage.setItem('memberId', defaultMember);
    }
  }

  public setEntityType(): void {
    const entityType = this.sessionService.getEntityType();
    sessionStorage.setItem('entityType', entityType);
    sessionStorage.setItem('selectedEntityType', entityType);
  }
}
